import httpClient from '../httpClient';

export async function getNumerosGerais() {
  try {
    const response = await httpClient.get(`/api/estatisticas/numeros-gerais`);

    // Verifica se a resposta contém os números gerais esperados
    if (response.data) {
      return response.data;
    } else {
      throw new Error('Resposta inesperada da API');
    }
  } catch (error) {
    // Verifica se o erro é uma instância da classe Error
    if (error instanceof Error) {
      throw new Error('Erro ao obter números gerais: ' + error.message);
    } else {
      // Caso o erro não seja do tipo Error, lança um erro genérico
      throw new Error('Erro desconhecido ao obter números gerais');
    }
  }
}
